export default __webpack_public_path__ + "static/treneri-monika-mihalikova-e93c0340365cc81f2fb12b44f07e6765.jpg";